import { useEffect } from 'react';
import { Navigate, useSearchParams } from 'react-router-dom';
import { ProtectedRoute } from '@/components/auth/ProtectedRoute';
import { DashboardLayout } from '@/components/layout/DashboardLayout';
import { isIndicacaoHostname, redirectIndicacaoHostToPortalfly } from '@/utils/indicacaoHost';

/**
 * Raiz `/`: redireciona `?ref=` → `/indicacao?ref=`; host indicacao.* → Portalfly;
 * demais casos seguem layout autenticado.
 */
export function RootPathResolver() {
  const [searchParams] = useSearchParams();
  const ref = searchParams.get('ref')?.trim() ?? '';

  useEffect(() => {
    redirectIndicacaoHostToPortalfly();
  }, []);

  if (typeof window !== 'undefined' && isIndicacaoHostname(window.location.hostname)) {
    return null;
  }

  if (ref) {
    return <Navigate to={`/indicacao?ref=${encodeURIComponent(ref)}`} replace />;
  }

  return (
    <ProtectedRoute>
      <DashboardLayout />
    </ProtectedRoute>
  );
}
